import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, TextField, Paper, withStyles, Button, FormHelperText } from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';

class RolePage extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    // this.initData = this.initData;
    this.state = {
      data: {
        name: '',
        description: '',
      },
      errorField: {
        name: false,
      },
      loading: false,
    };
  }
  async componentDidMount() {
    const { offset, limit, search, sort, order } = this.props.role.toJS();
    await this.props.role.getRole(offset, limit, search, sort, order);
    this.initData();
  }
  goBack() {
    this.props.role.setAction('action', true);
    this.props.history.goBack();
  }
  initData() {
    const { roles, loading } = this.props.role.toJS();
    const { id } = this.props.match.params;
    const roleId = Number(id);
    const showData = roles.data.find((item) => item.id === roleId);
    if (showData) {
      this.setState({
        data: {
          id: showData.id,
          name: showData.name,
          description: showData.description,
          confirmPassword: showData.password,
          loading: loading,
        },
      });
    }
  }
  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
  };

  handleCreateRole = async (data) => {
    const { t } = this.props;
    if (this.validate()) {
      try {
        const result = await this.props.role.createRole(data);
        if (result.statusCode === 200) {
          Swal.fire({ html: `<h4>${t('create_success')}`, type: 'success' }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              this.props.history.push('../roles');
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
            }
          });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          // Swal.fire({ html: `<h4>Failed to create<br/>${e.error.message}`, type: "error" });
          clearLocalStorage();
          window.location.href = '/login';
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      }
    }
  };

  handleEditRole = async (data) => {
    const { t } = this.props;
    if (this.validate()) {
      Swal.fire({
        html: `<h4>${t('edit_role')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('edit')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            const result = await this.props.role.updateRole(data);
            if (result.statusCode === 200) {
              Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
                if (resultSuccess.value) {
                  this.props.role.setAction('action', true);
                  this.props.history.push('../../roles');
                } else {
                  Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
                }
              });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
            }
          }
        }
      });
    }
  };

  validate() {
    const { data } = this.state;
    if (!data.name) {
      let checkName = !data.name ? true : false;
      this.setState({
        errorField: {
          name: checkName,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          name: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
  }

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data } = this.state;
    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_role')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateRole(data)}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data, loading } = this.state;
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_role')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleEditRole(data)}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormView() {
    const { classes, t } = this.props;
    const { data, loading } = this.state;
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_role')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/roles/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderFormView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  TitlePage: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 4,
    background: '#049588',
    height: '90px',
    margin: '-24px',
  },
  typo: {
    color: 'white',
    padding: '30px',
  },
});
export const page = inject('role')(observer(RolePage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
